import React from "react";
import {useAppDispatch} from "../../../../../../../../common/hook";
import {ALL_ACTS} from "../../../../../../../../entities/constants/constants";
import {ReactComponent as ArrayIcon} from '../../../../../../../../assets/main/groups/main-table/array-right.svg';
import {Link} from "react-router-dom";
import {setActiveTabs} from "../../../../../../../../app/top-tabs-reduser";




export const ActsCartsLink = () => {
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setActiveTabs([1]));
    };

    return (
        // ...
        <div className="block-arrow-link">
            <Link to="/payment-history" className="arrow-link" onClick={handleClick}>
                {ALL_ACTS}
                <ArrayIcon className="arrow"/>
            </Link>
        </div>

    );
};

